import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { NotificationService } from '../../_core/_services/notification.service';

@Component({
  selector: 'app-withdrawal-setup-guide',
  standalone: false,
  templateUrl: './withdrawal-setup-guide.html',
  styleUrl: './withdrawal-setup-guide.css'
})
export class WithdrawalSetupGuide {
  readonly gatewayMappingExample = `{
  "currencyCode": "NGN",
  "workflow": "Withdrawal",
  "paymentMethod": "bank-transfer",
  "frontendHint": "bank-form",
  "countryCode": "NG",
  "priority": 1,
  "isDefault": true,
  "isActive": true
}`;

  readonly bankOptionsJson = `{
  "type": "lookup",
  "lookupType": "institution",
  "filters": {
    "countryCode": "NG",
    "providerCode": "FLUTTERWAVE"
  },
  "valueField": "value",
  "labelField": "label"
}`;

  readonly accountNumberValidationJson = `{
  "minLength": 10,
  "maxLength": 10,
  "pattern": "^[0-9]+$",
  "message": "Account number must be 10 digits"
}`;

  readonly accountNumberMetadataJson = `{
  "resolve": {
    "type": "accountName",
    "triggerFields": ["bankCode", "accountNumber"],
    "resultField": "accountName"
  }
}`;

  readonly resolvedAccountNameMetadataJson = `{
  "readonly": true,
  "resolved": true
}`;

  readonly staticSelectJson = `{
  "type": "static",
  "options": [
    { "value": "savings", "label": "Savings" },
    { "value": "current", "label": "Current" }
  ]
}`;

  readonly emailValidationJson = `{
  "type": "email",
  "maxLength": 150,
  "message": "Enter a valid email address"
}`;

  constructor(
    private router: Router,
    private notificationService: NotificationService
  ) {}

  async copyText(value: string, label: string): Promise<void> {
    try {
      await navigator.clipboard.writeText(value);
      this.notificationService.showSuccess(`${label} copied.`, 'Success');
    } catch {
      this.notificationService.showError(`Failed to copy ${label}.`, 'Error');
    }
  }

  goTo(route: string): void {
    this.router.navigate([route]);
  }
}